export default "__VITE_ASSET__Do7$7oKA__"